import * as React from "react";
import {IListOfModules} from "../../../HubFramework/IHub";
import {getListOfAllModules} from "../../../Utils/modules";
import OdxAreaHeader from "../../../OdxComponents/NativeOdx/Odx-AreaHeader";
import OdxTable from "../../../OdxComponents/NativeOdx/Table/Odx-Table";
import {OdxTableRow} from "../../../OdxComponents/NativeOdx/Table/Odx-TableRow";
import {OdxTableCell} from "../../../OdxComponents/NativeOdx/Table/Odx-Tablecell";
import {useModuleViewTracking} from "../../../Utils/sentryTracking";
import {simplifyForHtmlId} from "../../../Utils/transformer";
import OdxContentBox from "../../../OdxComponents/NativeOdx/Odx-Contentbox";

const AllModulePageInformation = () => {

    useModuleViewTracking('hub-allmodulepageinformation')

    const baseId = 'hub-module-page-info';

    let mods: IListOfModules = getListOfAllModules()
    return <div id={`${baseId}-view`}>
        <OdxAreaHeader text={"Modules Usage"}
                       subTitle={"This page contains infos about all modules in DevSecOps Hub."}
                       odxSize={"large"}
                       id={`${baseId}-header`}
        />
        <OdxContentBox id={`${baseId}-content`}>
            <OdxTable className={"pt-10 table-fixed"}
                      variant={"striped"}
                      id={`${baseId}-table`}
                      headerData={
                          [
                              {name: "Title", sortable: true, title: "Title"},
                              {name: "Module Name", title: "Module Name"},
                              {name: "Pages", title: "Pages"},
                              {name: "Default Page", title: "Default Page"}
                          ]
                      }
            >
                {Object.keys(mods).map((key, index) => {
                    const moduleKey = simplifyForHtmlId(key || `module-${index}`);
                    return <OdxTableRow key={key ?? index} id={`${baseId}-row-${moduleKey}`}>
                        <OdxTableCell id={`${baseId}-cell-${moduleKey}-title`}>{mods[key].moduleContent.title}</OdxTableCell>
                        <OdxTableCell id={`${baseId}-cell-${moduleKey}-name`}>{mods[key].moduleContent.moduleName}</OdxTableCell>
                        <OdxTableCell id={`${baseId}-cell-${moduleKey}-pages`}>{mods[key].moduleContent.pages.filter((i) => i.displayName !== "").map((i) => i.displayName).join(', ')}</OdxTableCell>
                        <OdxTableCell id={`${baseId}-cell-${moduleKey}-default`}>{mods[key].moduleContent.defaultPage}</OdxTableCell>
                    </OdxTableRow>
                })}
            </OdxTable>
        </OdxContentBox>
    </div>
}

export default AllModulePageInformation;
